<template>
    <div class="text-xs-center">
        <v-dialog v-model="show" width="500">
            <v-card>
                <v-card-title>{{title}}</v-card-title>
                <v-card-text>{{text}}</v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="danger" @click="closeCallback">
                        {{closeText}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapGetters , mapMutations } from 'vuex'

export default {
    name: "message-box",     
    data () {
        return {
            dialog: this.value
        }
    },
    computed:{
        show(){
            return this.$store.state.app.messageBox.show;
        },
        title(){
            return this.$store.state.app.messageBox.title;
        },
        text(){
            return this.$store.state.app.messageBox.text;
        },                        
        closeText(){
            return this.$t("Common.close");
        }
    },
    methods:{
        ...mapMutations("app", ["setMessageBox"]),
        closeCallback(){
            this.$store.state.app.messageBox.callback();
            let messageBox = this.$store.state.app.messageBox;

            messageBox.show = false;
            this.setMessageBox(messageBox);            
        }
    }
}
</script>